import { User, Users, Shield, UserCheck, Briefcase, Scale } from "lucide-react";

// Six-avatar cast strip. Each slot renders whatever data is populated on the
// contract; missing roles show a grey placeholder so the layout stays stable.
const ROLES = [
  { key: "submitter",  Icon: User,        label: "Submitter" },
  { key: "approver",   Icon: UserCheck,   label: "BU Approver" },
  { key: "reviewer",   Icon: Users,       label: "BU Reviewer" },
  { key: "sponsor",    Icon: Briefcase,   label: "Exec Sponsor" },
  { key: "legal",      Icon: Scale,       label: "Legal Contact" },
  { key: "attorney",   Icon: Shield,      label: "Attorney" },
];

function initials(name) {
  return (name || "?").split(/\s+/).filter(Boolean).slice(0, 2).map(x => x[0]).join("").toUpperCase();
}

export default function PeopleStrip({ contract, onMessage }) {
  if (!contract) return null;
  const c = contract;
  const cast = {
    submitter: c.submitted_by_name || `${c.submitter_first_name || ""} ${c.submitter_last_name || ""}`.trim(),
    approver:  c.bu_approver_name,
    reviewer:  c.bu_reviewer_name,
    sponsor:   c.executive_sponsor_name,
    legal:     `${c.legal_contact_first_name || ""} ${c.legal_contact_last_name || ""}`.trim() || c.legal_contact_email,
    attorney:  c.assigned_attorney_name,
  };
  const emails = {
    submitter: c.submitted_by_email || c.submitter_email,
    approver:  c.bu_approver_email,
    reviewer:  c.bu_reviewer_email,
    sponsor:   c.executive_sponsor_email,
    legal:     c.legal_contact_email,
    attorney:  null,
  };
  return (
    <div className="mt-3 bg-white border border-slate-200 rounded-md p-3 flex flex-wrap items-center gap-4" data-testid="people-strip">
      {ROLES.map(r => {
        const name = cast[r.key];
        const email = emails[r.key];
        const filled = !!name && name.trim().length > 0;
        const clickable = filled && !!email && !!onMessage;
        const inner = (
          <>
            <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0 ${filled ? "bg-[#005289] text-white" : "bg-slate-100 text-slate-400"} ${clickable ? "ring-2 ring-transparent hover:ring-[#005289]/40 cursor-pointer" : ""}`}
                 title={filled ? `${r.label}: ${name}${email ? ` · ${email}` : ""}${clickable ? " · click to message" : ""}` : `${r.label}: not set`}>
              {filled ? initials(name) : <r.Icon className="w-3.5 h-3.5" />}
            </div>
            <div className="min-w-0">
              <div className="text-[9px] font-bold uppercase tracking-wider text-slate-500">{r.label}</div>
              <div className={`text-xs font-semibold truncate max-w-[140px] ${filled ? "text-slate-900" : "text-slate-400 italic"}`}>{filled ? name : "not set"}</div>
            </div>
          </>
        );
        return clickable ? (
          <button key={r.key} onClick={() => onMessage({ name, email, label: r.label })}
                  data-testid={`people-${r.key}`}
                  className="flex items-center gap-2 min-w-0 text-left hover:opacity-80">
            {inner}
          </button>
        ) : (
          <div key={r.key} className="flex items-center gap-2 min-w-0" data-testid={`people-${r.key}`}>
            {inner}
          </div>
        );
      })}
    </div>
  );
}
